//Отправить лог
export const sendLog = (serverApi, page, action, request, error, data) => {
    let object = {
        page:  page,
        action: action,
        request: request,
        error: error,
        data: data,
    };
    serverApi.addLog(object).then((res) => {
        //console.log(res?.data?.success);
    }).catch((errors) => console.log('Ошибка отправки лога', errors));
};
